module.exports = __webpack_public_path__ + "static/Wiked-2fa6956c8161264a29cffe197d65c4a7.png";